import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

const BASE = typeof window !== "undefined" && window.location.hostname !== "localhost"
  ? "https://quickry-ivrv.onrender.com/api"
  : "http://localhost:5000/api";

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("qr_token");
    if (token) fetchMe(token);
    else setLoading(false);
  }, []);

  const fetchMe = async (token) => {
    try {
      const res  = await fetch(`${BASE}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) setUser(data.data);
      else { localStorage.removeItem("qr_token"); setUser(null); }
    } catch {
      localStorage.removeItem("qr_token");
    }
    setLoading(false);
  };

  // Send OTP to email
  const sendOTP = async (email) => {
    const res = await fetch(`${BASE}/auth/send-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    return res.json();
  };

  // Verify OTP — sets token + user
  const verifyOTP = async (email, otp) => {
    const res  = await fetch(`${BASE}/auth/verify-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp }),
    });
    const data = await res.json();
    if (data.success && data.token) {
      localStorage.setItem("qr_token", data.token);
      setUser(data.data);
    }
    return data;
  };

  // login — called after verifyOTP from Login page
  const login = (userData, token) => {
    if (token) localStorage.setItem("qr_token", token);
    if (userData) setUser(userData);
  };

  // getToken — helper for API calls
  const getToken = () => localStorage.getItem("qr_token") || "";

  // updateProfile — update user in context after profile save
  const updateProfile = (updatedUser) => {
    setUser(prev => ({ ...prev, ...updatedUser }));
  };

  const logout = () => {
    localStorage.removeItem("qr_token");
    localStorage.removeItem("qr_cart");
    setUser(null);
  };

  const isLoggedIn = !!localStorage.getItem("qr_token");

  return (
    <AuthContext.Provider value={{
      user, loading, isLoggedIn,
      sendOTP, verifyOTP, login,
      logout, setUser, getToken, updateProfile,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}